import formatPrice from 'helpers/format-price/formatPrice';
import { createIconLoader, removeIconLoader } from 'helpers/loader/loader';
import debounce from 'helpers/debounce/debounce';
import getTranslation from 'helpers/translation/getTranslation';
import axios from 'axios';

export default (function () {
    const tileCalcSettings = {};

    const initTileCalculator = function () {
        const tileCalculatorActive = document.querySelector('.tile-calculator-active');

        if (!tileCalculatorActive) {
            return;
        }

        tileCalcSettings.formElement = tileCalculatorActive.querySelector('#tile-calculator-form');

        // Check if formElement is available, can be null when product is not in stock
        if (!tileCalcSettings.formElement) {
            return;
        }

        tileCalcSettings.parentElement = tileCalculatorActive;
        tileCalcSettings.tileBoxQuantityEl = tileCalcSettings.parentElement.querySelector('#tile-quantity');
        tileCalcSettings.conversionFactor = parseFloat(tileCalcSettings.formElement.getAttribute('data-conversion'));
        tileCalcSettings.price = parseFloat(tileCalcSettings.formElement.getAttribute('data-price'));
        tileCalcSettings.stickyCart = document.querySelector('#sticky-cart'); // null when element is not found
        if (tileCalcSettings.stickyCart) {
            tileCalcSettings.stickyCartPrice = tileCalcSettings.stickyCart.querySelector('.price-area').innerHTML;
        }

        addTileCalcEventListeners(); //Create event listeners
    };

    /*-----------------------------Add event listeners------------------------------*/
    const addTileCalcEventListeners = function () {
        tileCalcSettings.parentElement.addEventListener('keyup', calculateTotals); //Add change event listener
        tileCalcSettings.parentElement.addEventListener('change', calculateTotals); //Add change event listener

        if (productObj && productObj.productId && productObj.calculatorProductUrl && frontendVars.siteviewId) {
            tileCalcSettings.parentElement.addEventListener(
                'keyup',
                debounce(function (e) {
                    if (e.key === 'Tab' || e.key === 'Shift') {
                        // if the 'tab' key is released, do not recalculate. if we do, we'll get weird calculations due
                        // to earlier roundings. the key up events for the input numbers are enough.
                        return;
                    }

                    _reloadDeliveryTime(frontendVars.siteviewId, productObj.productId);
                }, 300)
            );
        }
    };

    /*-----------------------------Reload tile calculator------------------------------*/
    const reloadTileCalculator = function () {
        //We need to reload the calculator because it will be added through AJAX in js/pages/product/addToCart.js
        tileCalcSettings.parentElement.removeEventListener('keyup', calculateTotals); //Remove eventlistener
        tileCalcSettings.parentElement.removeEventListener('change', calculateTotals); //Remove eventlistener
        initTileCalculator(); //Initiate calculator again
    };

    /*-----------------------------Calculate total boxes------------------------------*/
    const calculateTotals = function (e) {
        if (e.key === 'Tab' || e.key === 'Shift') {
            // if the 'tab' key is released, do not recalculate. if we do, we'll get weird calculations due
            // to earlier roundings. the key up events for the input numbers are enough.
            return;
        }

        const tileCalcForm = tileCalcSettings.parentElement; //Tile calculation form
        const userAmountEl = tileCalcForm.querySelector('#user-amount'); //Get user amount element
        let userAmount = userAmountEl && userAmountEl.value ? parseFloat(userAmountEl.value) : 0; //Set user amount to value when filled
        const cuttingLossEl = tileCalcForm.querySelector('#cutting-loss'); //Get cutting loss element
        const cuttingLoss = cuttingLossEl ? parseInt(cuttingLossEl.value) : 0; //Set cutting loss
        const boxesChanged = e ? e.target.closest('#tile-quantity') : false; //Check if input changed is boxAmount.
        const totalAmountEl = tileCalcForm.querySelector('#total-amount'); //Get total amount element
        const currentStock = tileCalcSettings.formElement.getAttribute('data-currentstock');

        //Calculate cuttingloss and total userAmount
        if (cuttingLossEl && userAmountEl && !boxesChanged) {
            const cuttingLossAmount = (userAmount / 100) * cuttingLoss; //Calculate cutting loss amount
            userAmount = userAmount + cuttingLossAmount; //Add cuttingloss to userAmount
        }

        //Calculate total amount
        if (totalAmountEl && tileCalcSettings.tileBoxQuantityEl && userAmount > -1 && !boxesChanged) {
            totalAmountEl.value = parseFloat(userAmount).toFixed(2); //Show total amount round to 2 decimals
            tileCalcSettings.tileBoxQuantityEl.value = Math.ceil(userAmount / tileCalcSettings.conversionFactor); //Calculate total boxes
        }

        //Calculate m2 when boxes amount changes
        if (boxesChanged && cuttingLossEl && userAmountEl && totalAmountEl) {
            const boxQuantity = parseInt(tileCalcSettings.tileBoxQuantityEl.value);
            const totalAmount = boxQuantity * tileCalcSettings.conversionFactor;
            totalAmountEl.value = parseFloat(totalAmount).toFixed(2);
            userAmountEl.value = parseFloat((1 - cuttingLoss / 100) * totalAmount).toFixed(2);
        }

        //Calculate total price when box amount is set
        if (tileCalcSettings.tileBoxQuantityEl) {
            calculateTotalPrice(); //Calculate total price
            if (tileCalcSettings.tileBoxQuantity > 1) {
                document.querySelector('.multiple-boxes').classList.remove('d-none');
                document.querySelector('.single-box').classList.add('d-none');
            } else {
                document.querySelector('.multiple-boxes').classList.add('d-none');
                document.querySelector('.single-box').classList.remove('d-none');
            }
        }

        if (currentStock) {
            const currentStock = tileCalcSettings.formElement.getAttribute('data-currentstock');
            const boxQuantity = parseInt(tileCalcSettings.tileBoxQuantityEl.value);
            const stockErrorMessage = tileCalcForm.querySelector('#not-in-stock-error');

            if (boxQuantity > currentStock) {
                stockErrorMessage.classList.remove('d-none');
                tileCalcSettings.tileBoxQuantityEl.classList.add('is-invalid');
            } else {
                stockErrorMessage.classList.add('d-none');
                tileCalcSettings.tileBoxQuantityEl.classList.remove('is-invalid');
            }
        }
    };

    /*-----------------------------Calculate total price------------------------------*/
    const calculateTotalPrice = function () {
        const tileCalcForm = tileCalcSettings.parentElement; //Tile form
        const addToCartForm = document.querySelector('#addProductToCartForm');
        const totalPriceEl = tileCalcForm.querySelector('#tile-total-price'); //Element which holds the total price display
        const priceEl = totalPriceEl.querySelector('.unit-end-price'); // Element which contain the price

        tileCalcSettings.tileBoxQuantity =
            tileCalcSettings.tileBoxQuantityEl.value && tileCalcSettings.tileBoxQuantityEl.value > 0
                ? parseFloat(tileCalcSettings.tileBoxQuantityEl.value)
                : 0;

        //Calculate total price
        if (tileCalcSettings.tileBoxQuantity && tileCalcSettings.tileBoxQuantity > 0) {
            if (addToCartForm) {
                addToCartForm.querySelector('input[name="aantal"]').value = tileCalcSettings.tileBoxQuantity; //Set tile box quantity to quantity of product form. When we add the product to cart we add the correct amount.
                document.querySelector('.box-input-amount').innerHTML = tileCalcSettings.tileBoxQuantity;
                const totalAmountElement = document.querySelector('#total-amount');
                if (totalAmountElement) {
                    const totalAmount =
                        parseInt(tileCalcSettings.tileBoxQuantityEl.value) * tileCalcSettings.conversionFactor;
                    document.querySelector('.calc-total-amount-m2').innerHTML =
                        `${totalAmount.toFixed(2).replace('.', ',')} m²`;
                }
            }
            priceEl.innerHTML = formatPrice(tileCalcSettings.tileBoxQuantity * tileCalcSettings.price); //Calculate total price and  format price
            totalPriceEl.classList.remove('d-none'); //Show total price element
            //Only update stickyCart when stickyCart is present on page.
            if (tileCalcSettings.stickyCart) {
                tileCalcSettings.stickyCart.querySelector('input[name="aantal"]').value =
                    tileCalcSettings.tileBoxQuantity;
                tileCalcSettings.stickyCart.querySelector('.price-area').innerHTML =
                    totalPriceEl.querySelector('.price-area').innerHTML;
            }
        } else {
            totalPriceEl.classList.add('d-none'); //Hide total price element
            if (addToCartForm) {
                addToCartForm.querySelector('input[name="aantal"]').value = 1; //Reset amount to 1
            }
            if (tileCalcSettings.stickyCart) {
                tileCalcSettings.stickyCart.querySelector('input[name="aantal"]').value = 1; //Reset amount to 1
                tileCalcSettings.stickyCart.querySelector('.price-area').innerHTML = tileCalcSettings.stickyCartPrice;
            }
        }
    };

    /*-----------------------------Reload delivery time------------------------------*/
    const _reloadDeliveryTime = function (siteViewId, productId) {
        const deliveryIndicator = document.querySelector('#delivery-indicator');
        const deliveryText = document.querySelector('.delivery-indicator-text');

        // Set loading state and add loading spinner to delivery time text
        deliveryIndicator.classList.add('is-loading');
        createIconLoader(deliveryIndicator, 'greys');

        axios
            .get(productObj.calculatorProductUrl, {
                params: {
                    siteViewId: parseInt(siteViewId),
                    productId: parseInt(productId),
                    quantity: tileCalcSettings.tileBoxQuantity
                }
            })
            .then((response) => {
                const { deliveryTime } = response.data;

                // Update delivery time text on product page
                if (deliveryTime === 1) {
                    deliveryText.innerHTML = getTranslation('product', 'ORDER_TODAY_DELIVER_TOMORROW');
                } else if (deliveryTime === 2) {
                    deliveryText.innerHTML = getTranslation('product', 'ORDER_TODAY_DELIVER_THE_DAY_AFTER_TOMORROW');
                } else {
                    deliveryText.innerHTML = getTranslation('product', 'DELIVER_IN_X_WORKINGDAYS', [`${deliveryTime}`]);
                }
            })
            .finally(() => {
                // Remove loading state from delivery time
                removeIconLoader(deliveryIndicator);
                deliveryIndicator.classList.remove('is-loading');
            });
    };

    /*-----------------------------PUBLIC METHODS------------------------------*/
    return {
        init: initTileCalculator,
        reload: reloadTileCalculator
    };
})();
